<div class="container-fluid py-5">
  <div class="row">
    <div class="col-md-12">
      <div class="card shadow-sm">
        <div class="card-body p-5">
					<div class="row pb-4">
            <div class="col">
              <h3 class="p-0">Extend Closing Date</h3>
            </div>
            <div class="col text-right">
							<div class="dropdown">
								<button type="button" class="btn btn-outline-secondary btn-more w-auto rounded-circle" id="more-options" data-toggle="dropdown" aria-label="More Options" aria-haspopup="true" aria-expanded="false">
									<span class="ellipsis" aria-hidden="true">&#8943;</span>
							  </button>
							  <div *ngIf = "businessType === 'FRT' " class="dropdown-menu dropdown-menu-right">
									<h6 class="dropdown-header text-uppercase px-4">More Options</h6>
									<a class="dropdown-item" routerLink="/frtratefileopen" routerLinkActive="active">Open Rate Filing</a>
                </div>
                <div *ngIf = "businessType === 'HHG' " class="dropdown-menu dropdown-menu-right">
									<h6 class="dropdown-header text-uppercase px-4">More Options</h6>
									<a class="dropdown-item" routerLink="/hhgratefileopen" routerLinkActive="active">Open Rate Filing</a>
							  </div>
							</div>
            </div>
          </div>

          <div *ngIf="updateSuccessful" class="alert alert-success">
						Your TSP extension has been successfully updated.
          </div>
          <div *ngIf="updateFailure" class="alert alert-danger">
            An error has occurred. Please contact support.
          </div>

          <form [formGroup]="rateFileTspExtForm" >
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="rate_type">Type</label>
                <select id="rate_type" class="w-100" formControlName="rateType" (change)="changeRateType($event)"
								[ngClass]="{
									'border-success': this.rateFileTspExtForm.get('rateType').valid && (this.rateFileTspExtForm.get('rateType').touched || this.rateFileTspExtForm.get('rateType').dirty),
									'border-danger': this.rateFileTspExtForm.get('rateType').invalid && (this.rateFileTspExtForm.get('rateType').touched || this.rateFileTspExtForm.get('rateType').dirty)
								}"
								>
                  <option value="null" selected disabled>Choose...</option>
                  <option value="FRT Rate Filing">Freight</option>
                  <option value="HHG Rate Filing">Household Goods</option>
                </select>
								<div *ngIf="this.rateFileTspExtForm.get('rateType').invalid && this.rateFileTspExtForm.get('rateType').touched || this.rateFileTspExtForm.get('rateType').dirty">
                  <div class="text-danger" *ngIf="this.rateFileTspExtForm.get('rateType').hasError('required')">
										<span class="fa fa-warning"></span> Type is required
									</div>
	              </div>
              </div>
              <div class="form-group col-md-4" *ngIf="this.rateFileTspExtForm.get('rateType').value !== null">
                <label for="filing_period">Filing Period</label>
                <select id="filing_period" class="w-100" formControlName="ratePeriod" (change)="changeRatePerid($event)"
								[ngClass]="{
									'border-success': this.rateFileTspExtForm.get('ratePeriod').valid && (this.rateFileTspExtForm.get('ratePeriod').touched || this.rateFileTspExtForm.get('ratePeriod').dirty),
									'border-danger': this.rateFileTspExtForm.get('ratePeriod').invalid && (this.rateFileTspExtForm.get('ratePeriod').touched || this.rateFileTspExtForm.get('ratePeriod').dirty)
								}"
								>
                  <option value="null" selected disabled>Choose...</option>
                  <option *ngFor="let ratePeriodDetail of ratePeriodDetails" [value]="ratePeriodDetail.controlId">{{ratePeriodDetail.effectiveDate | date: 'M/d/y'}} - {{ratePeriodDetail.expiryDate | date: 'M/d/y'}}</option>
                </select>
								<div *ngIf="this.rateFileTspExtForm.get('ratePeriod').invalid && this.rateFileTspExtForm.get('ratePeriod').touched || this.rateFileTspExtForm.get('ratePeriod').dirty">
                  <div class="text-danger" *ngIf="this.rateFileTspExtForm.get('ratePeriod').hasError('required')">
                  	<span class="fa fa-warning"></span> Filing Period is required
                  </div>
	              </div>
              </div>
              <div class="form-group col-md-4" *ngIf="this.rateFileTspExtForm.get('rateType').value !== null && this.rateFileTspExtForm.get('ratePeriod').value !== null">
                <label for="scac">SCAC</label>
                <input type="text" [attr.disabled]="disabled?'':null" oninput="this.value = this.value.toUpperCase()"
                  id="scac" class="w-100" placeholder="Enter Keyword" formControlName='carrierKeyword'
                  [typeahead]="typeaheadlist" [typeaheadMinLength]="minLengthToSearch" [typeaheadOptionsLimit]="10"
                  [maxlength]="maxCharLength">
              </div>
            </div>
            <button type="button" class="btn btn-primary w-auto mt-4" [disabled]="this.rateFileTspExtForm.get('carrierKeyword').value === ''" (click)="getCarrierDetails()">Get Details</button>

						<div *ngIf="this.rateFileTspExtForm.get('rateType').value !== null && this.rateFileTspExtForm.get('ratePeriod').value !== null && this.rateFileTspExtForm.get('carrierKeyword').value !== null">
							<hr>
							<div class="form-row">
								<div class="form-group col-md-4">
	                <label for="carrier">Carrier</label>
	                <input type="text" id="carrier" class="w-100" readonly formControlName="carrierSelected">
								</div>
	              <div class="form-group col-md-4">
	                <label for="open_date">Effective Date</label>
	                <input type="text" id="open_date" class="w-100" placeholder="mm/dd/yyyy" formControlName="rateEffeciveDate" readonly [value]="this.rateFileTspExtForm.get('rateEffeciveDate').value | date: 'M/d/y'">
	              </div>
	              <div class="form-group col-md-4">
	                <label for="close_date">Expiration Date</label>
	                <input type="text" id="close_date" class="w-100" placeholder="mm/dd/yyyy" formControlName="tspExpiryDate" [value]="this.rateFileTspExtForm.get('tspExpiryDate').value | date: 'M/d/y'" bsDatepicker [bsConfig]="datePickerConfig" placement="left">
									<div *ngIf="this.rateFileTspExtForm.get('tspExpiryDate').invalid && this.rateFileTspExtForm.get('tspExpiryDate').touched || this.rateFileTspExtForm.get('tspExpiryDate').dirty">
	                  <div class="text-danger" *ngIf="this.rateFileTspExtForm.get('tspExpiryDate').hasError('required') && !updateSuccessful">
	                    <span class="fa fa-warning"></span> Expiration Date is required
	                  </div>
	                </div>
									<input type="text" class="d-none" formControlName="rateExpiryDate" [value]="this.rateFileTspExtForm.get('rateExpiryDate').value | date: 'M/d/y'">
									<input type="text" class="d-none" formControlName="rateReleaseDate" [value]="this.rateFileTspExtForm.get('rateReleaseDate').value | date: 'M/d/y'">
	              </div>
	            </div>
	            <!--<button type="button" class="btn btn-primary w-auto mt-4" *ngIf="this.rateFileTspExtForm.get('carrierSelected').value !== '' && this.rateFileTspExtForm.get('rateEffeciveDate').value !== ''" [disabled]="(this.rateFileTspExtForm.invalid || this.updateSuccessful) || this.buttonDisable" (click)="saveTSPExpirtyDate()">Save</button>-->
							<button type="button" class="btn btn-primary w-auto mt-4" [disabled]="(this.rateFileTspExtForm.invalid || this.updateSuccessful) || this.buttonDisable" (click)="saveTSPExpirtyDate()">Save</button>
            </div>
            <div class="card shadow-sm mt-5" *ngIf="this.rateFileTspExtForm.get('carrierSelectedForTable').value != ''">
              <div class="card-body p-5">
                <table class="table table-striped mt-5">
                  <thead>
                    <tr>
                      <th>Carrier</th>
                      <th>Open Date</th>
                      <th>Close Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><input type="text" id="Carrier" class="w-100" readonly  formControlName="carrierSelectedForTable"></td>
                     <td><input type="text" id="open_date_table" class="w-100" placeholder="mm/dd/yyyy" formControlName="rateEffeciveDateForTable" readonly  [value]="this.rateFileTspExtForm.get('rateEffeciveDateForTable').value | date: 'M/d/y'"></td>
                     <td><input type="text" id="close_date_table" class="w-100" placeholder="mm/dd/yyyy" formControlName="rateExpiryDateForTable" readonly  [value]="this.rateFileTspExtForm.get('rateExpiryDateForTable').value | date: 'M/d/y'"></td>
                   </tr>
                  </tbody>
                </table>
              </div>
            </div>
					</form>
				</div>
			</div>
    </div>
  </div>
</div>
